import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';
import { UsuarioSharedModule } from '../../usuario/usuario-shared.module';
import { UnidadeNegocioUsuarioComponent } from './unidade-negocio-usuario.component';

@NgModule({
    imports: [
        SharedModule,
        UsuarioSharedModule
    ],
    declarations: [
        UnidadeNegocioUsuarioComponent
    ],
    exports: [
        UnidadeNegocioUsuarioComponent
    ]
})
export class UnidadeNegocioUsuarioModule { }
